import React, { useState, useEffect } from 'react';
import { MapPin, Calendar, Users, Search } from 'lucide-react';
import { API_BASE } from './lib/runtimeConfig';

const DEFAULT_BG = 'https://images.unsplash.com/photo-1506929199175-63412ee239a8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80';

const Hero = () => {
  const [search, setSearch] = useState({ location: '', checkIn: '', checkOut: '', guests: 1 });
  const [content, setContent] = useState({
    heroBannerTitle:    'Encuentra tu próximo paraíso',
    heroBannerSubtitle: 'Apartamentos exclusivos y experiencias náuticas en el Caribe',
    heroBannerBg:       null,
    heroBannerCtaText:  'Reservar ahora',
    heroBannerCtaUrl:   '/propiedades',
  });

  useEffect(() => {
    fetch(`${API_BASE}/api/settings/public-content`)
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d) setContent(c => ({ ...c, ...d })); })
      .catch(() => {});
  }, []);

  const bgImage = content.heroBannerBg || DEFAULT_BG;

  return (
    <div style={{ ...heroContainer, backgroundImage: `url("${bgImage}")` }}>
      <div style={overlay}></div>
      <div style={contentWrapper}>
        <h1 style={titleStyle}>{content.heroBannerTitle}</h1>
        <p style={subtitleStyle}>{content.heroBannerSubtitle}</p>

        <div style={searchBarContainer}>
          <div style={inputGroup}>
            <label style={labelStyle}><MapPin size={12}/> UBICACIÓN</label>
            <select style={selectStyle} onChange={(e) => setSearch({...search, location: e.target.value})}>
              <option value="">¿A dónde vas?</option>
              <option value="cartagena">Cartagena</option>
              <option value="islas">Islas del Rosario</option>
              <option value="barú">Barú</option>
            </select>
          </div>
          <div style={divider}></div>
          <div style={inputGroup}>
            <label style={labelStyle}><Calendar size={12}/> LLEGADA</label>
            <input type="date" style={inputStyle} onChange={(e) => setSearch({...search, checkIn: e.target.value})} />
          </div>
          <div style={divider}></div>
          <div style={inputGroup}>
            <label style={labelStyle}><Calendar size={12}/> SALIDA</label>
            <input type="date" style={inputStyle} onChange={(e) => setSearch({...search, checkOut: e.target.value})} />
          </div>
          <div style={divider}></div>
          <div style={inputGroup}>
            <label style={labelStyle}><Users size={12}/> PERSONAS</label>
            <input type="number" min="1" placeholder="¿Cuántos?" style={inputStyle} onChange={(e) => setSearch({...search, guests: e.target.value})} />
          </div>
          <button style={searchBtn} onClick={() => {
            const params = new URLSearchParams({ location: search.location, checkIn: search.checkIn, checkOut: search.checkOut, guests: search.guests });
            window.location.href = `${content.heroBannerCtaUrl}?${params.toString()}`;
          }}>
            <Search size={20} color="white" />
            <span style={btnText}>{content.heroBannerCtaText}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

const heroContainer = {
  height: '75vh', width: '100%',
  backgroundSize: 'cover', backgroundPosition: 'center',
  position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white'
};
const overlay = {
  position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
  background: 'linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.1))', zIndex: 1
};
const contentWrapper = {
  position: 'relative', zIndex: 2, textAlign: 'center', width: '100%', maxWidth: '1100px', padding: '0 20px'
};
const titleStyle    = { fontSize: '48px', fontWeight: '900', marginBottom: '10px', textShadow: '2px 2px 10px rgba(0,0,0,0.3)' };
const subtitleStyle = { fontSize: '18px', marginBottom: '40px', fontWeight: '400' };
const searchBarContainer = {
  backgroundColor: 'white', borderRadius: '50px', padding: '10px 20px',
  display: 'flex', alignItems: 'center', boxShadow: '0 15px 35px rgba(0,0,0,0.2)', gap: '10px'
};
const inputGroup  = { display: 'flex', flexDirection: 'column', flex: 1, textAlign: 'left', padding: '5px 15px' };
const labelStyle  = { fontSize: '10px', fontWeight: '800', color: '#003366', marginBottom: '4px', display: 'flex', alignItems: 'center', gap: '4px' };
const inputStyle  = { border: 'none', outline: 'none', fontSize: '14px', color: '#333', background: 'transparent' };
const selectStyle = { ...inputStyle, cursor: 'pointer' };
const divider     = { width: '1px', height: '40px', backgroundColor: '#eee' };
const searchBtn   = {
  backgroundColor: '#003366', border: 'none', borderRadius: '40px', padding: '15px 25px',
  display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', transition: 'transform 0.2s'
};
const btnText = { color: 'white', fontWeight: 'bold', fontSize: '14px' };

export default Hero;
